var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "_tablew _isth",
      class: {
        _fixed: _vm.fixed,
        _sth: _vm.stickyhead,
        _stc: _vm.stickycol,
        _row: _vm.row,
        _sr: _vm.selectRow
      }
    },
    [
      _c(
        "table",
        {
          ref: "table",
          staticClass: "_table",
          class: _vm.numeric,
          style: _vm.width ? "min-width:" + _vm.width : null
        },
        [
          _vm.fixed
            ? _c(
                "colgroup",
                { ref: "colgroup" },
                [
                  _vm.select
                    ? _c("col", { staticStyle: { width: "38px" } })
                    : _vm._e(),
                  _vm._l(_vm.col, function(c, i) {
                    return _c("col", {
                      class: { hide: _vm.colHide[i] },
                      style: {
                        width: /fr$/.test(c.width)
                          ? parseFloat(c.width) * _vm.colMul + "%"
                          : c.width || 0
                      }
                    })
                  })
                ],
                2
              )
            : _vm._e(),
          _c("thead", { ref: "thead", staticClass: "_ns", class: _vm.id }, [
            _c(
              "tr",
              [
                _vm.select
                  ? _c(
                      "th",
                      { staticClass: "nopad" },
                      [
                        _vm.select && _vm.select != "radio"
                          ? _c("ib-checkbox", {
                              attrs: { disabled: _vm.selectDisabled },
                              model: {
                                value: _vm.selectAll,
                                callback: function($$v) {
                                  _vm.selectAll = $$v
                                },
                                expression: "selectAll"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._l(_vm.col, function(th, i) {
                  return _c(
                    "th",
                    {
                      class: { sort: th.sort, sorted: _vm.sortCol == i },
                      on: {
                        click: function($event) {
                          return _vm.sortBy(i)
                        }
                      }
                    },
                    [
                      _c("div", [
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(th.title))
                        ]),
                        _vm._v("  "),
                        _c("span", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.colHide[i],
                              expression: "!colHide[i]"
                            }
                          ],
                          staticClass: "arrow",
                          class: _vm.sortDirs[i] > 0 ? "asc" : "dsc"
                        })
                      ])
                    ]
                  )
                })
              ],
              2
            )
          ]),
          _vm.data.length
            ? _c(
                "tbody",
                _vm._l(_vm.sorted, function(tr, index) {
                  return _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.visible[tr.id],
                          expression: "visible[tr.id]"
                        }
                      ],
                      class: {
                        selected: _vm.selected.indexOf(tr.id) >= 0,
                        _disabled: tr.disabled
                      },
                      on: {
                        click: function($event) {
                          return _vm.trClick(tr, index)
                        }
                      }
                    },
                    [
                      _vm.select
                        ? _c(
                            "td",
                            { staticClass: "nopad" },
                            [
                              _c(
                                _vm.select == "radio"
                                  ? "ib-radio"
                                  : "ib-checkbox",
                                {
                                  ref: "sel" + tr.id,
                                  refInFor: true,
                                  tag: "component",
                                  attrs: {
                                    name: _vm.name || "table" + _vm._uid,
                                    val: tr.id,
                                    required: _vm.required,
                                    disabled: tr.disabled,
                                    error: _vm.error,
                                    errorMissing: _vm.errorMissing
                                  },
                                  on: { input: _vm.input },
                                  model: {
                                    value: _vm.selected,
                                    callback: function($$v) {
                                      _vm.selected = $$v
                                    },
                                    expression: "selected"
                                  }
                                }
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._t("default", null, null, tr.data)
                    ],
                    2
                  )
                }),
                0
              )
            : _c("tbody", [
                _c("tr", [
                  _c(
                    "td",
                    { attrs: { colspan: _vm.cols } },
                    [_vm._t("empty")],
                    2
                  )
                ])
              ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }